import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {DataObjectId} from 'yougile-model'
import {UserProxy} from '../../extensions/proxies/user-proxy'
import {UserAvatarUtils} from '../../extensions/user-avatar-utils'
import {UserAvatarV2} from '../common/user-avatar-v2/user-avatar-v2'
import {companyLoginStore} from './company-login-store'
import {Company} from './types'

export const CompanyLoginMain = observer(() => {
  const {company} = companyLoginStore.state

  const bem = Util.bemFrom('company-login')
  if (!company) {
    return null
  }

  const user = getUser(company)

  return (
    <div className={bem('panel')}>
      {company.user && user ? (
        <div className={bem('user')}>
          <div className={bem('user-label')}>
            {Lang.msg.permission.loggedInAs}:
          </div>
          <div className={bem('current')}>
            <UserAvatarV2 {...user} hideStatus={true} className={bem('ava')} />
            <div className={bem('username')}>{company.user.name}</div>
          </div>
          <div className={bem('user-email')}>({company.user.email})</div>

          <div
            className={bem('enter-current')}
            onClick={companyLoginStore.enterCurrentCompany}
          >
            {Lang.msg.permission.enterCompany}
          </div>
          <div className={bem('enter-other')}>
            <span className="_link" onClick={companyLoginStore.setScreenEnter}>
              {Lang.msg.permission.enterOther}
            </span>
          </div>
          <div className={bem('register-other')}>
            <span
              className="_link"
              onClick={companyLoginStore.setScreenRegister}
            >
              {Lang.msg.permission.register}
            </span>
          </div>
        </div>
      ) : (
        <div className={bem('no-user')}>
          <div>
            {Lang.msg.permission.regLinkPageHint1} <b>“{company.name}”</b>
          </div>
          <div>{Lang.msg.permission.regLinkPageHint2}:</div>

          <div className={bem('enter-other')}>
            <span className="_link" onClick={companyLoginStore.setScreenEnter}>
              {Lang.msg.permission.regLinkSingIn}
            </span>
          </div>
          <div className={bem('register-other')}>
            <span
              className="_link"
              onClick={companyLoginStore.setScreenRegister}
            >
              {Lang.msg.permission.regLinkSingUp}
            </span>
          </div>
        </div>
      )}
    </div>
  )
})

const getUser = (company: Company): UserProxy | undefined => {
  if (!company.user) {
    return undefined
  }

  const {avaShortName, preview, avaColorByName} = UserAvatarUtils

  return {
    userId: undefined as unknown as DataObjectId,
    userImage: preview(company.user.avatar),
    userInfo: undefined as unknown as string,
    userName: company.user.name,
    userShortName: avaShortName(company.user.name, {
      id: undefined as unknown as DataObjectId,
      email: company.user.email
    }),
    userBackgroundColor: avaColorByName(company.user.name, company.user.email),
    userStatus: 'online',
    userIsInDoNotDisturbMode: false,
    userIsAdmin: false,
    userEmail: company.user.email,
    deleted: false
  }
}
